"use client";

import { getRequestNextPageParam } from "../../../../lib/utils/getRequestNextPageParam";
import type { UseRequestInfiniteQueryProps } from "../../../../request/hooks/useRequestInfiniteQuery";
import { useRequestInfiniteQuery } from "../../../../request/hooks/useRequestInfiniteQuery";
import { keyCommunitiesAdminCampaignDonors } from "./keyCommunitiesAdminCampaignDonors";
import { ADMIN_CAMPAIGN_DONORS_PAGE_SIZE } from "./requestCommunitiesAdminCampaignDonors";
import type { CampaignDonorsResponse } from "./schema/givingCampaignDonorsSchema";
import { campaignDonorsResponseSchema } from "./schema/givingCampaignDonorsSchema";

type useRequestCommunitiesAdminCampaignDonorsProps =
  UseRequestInfiniteQueryProps & {
    communityId: number;
    campaignId: number;
  };

export const useRequestCommunitiesAdminCampaignDonors = ({
  communityId,
  campaignId,
  ...props
}: useRequestCommunitiesAdminCampaignDonorsProps) => {
  return {
    infiniteQuery: useRequestInfiniteQuery<typeof campaignDonorsResponseSchema>(
      {
        getNextPageParam: (
          lastPage: CampaignDonorsResponse,
          _allPages: CampaignDonorsResponse[],
          lastPageParam: number,
        ) =>
          getRequestNextPageParam({
            total: lastPage.total,
            lastPageParam,
            pageSize: ADMIN_CAMPAIGN_DONORS_PAGE_SIZE,
          }),
        initialPageParam: 0,
        placeholderData: (previousData) => previousData,
        queryFnRequestProps: ({ pageParam }) => ({
          schema: campaignDonorsResponseSchema,
          urlBackendPath: `/communities/${communityId}/admin/campaigns/${campaignId}/donors?page=${pageParam}&per_page=${ADMIN_CAMPAIGN_DONORS_PAGE_SIZE}`,
        }),
        enabledWithoutSessionToken: false,
        queryKey: keyCommunitiesAdminCampaignDonors({
          communityId,
          campaignId,
        }),
        ...props,
      },
    ),
  };
};
